/* istanbul ignore file */
import { snakeCase } from 'lodash';
import { OFFICE_NAMES, OfficeDropdown as EmployeeOfficeDropdown } from 'domain/shared/employee';

const OfficeCodeDropdown = (props: any) => {
  const mapResults = (office: any) => ({
    value: snakeCase(office.name).toUpperCase(),
    label: OFFICE_NAMES[office.name],
  });

  return <EmployeeOfficeDropdown {...props} mapResults={mapResults} />;
};

export default OfficeCodeDropdown;
